module.exports = __webpack_public_path__ + "img/碳中和碳汇管理平台.d1f339bf.png";